import React, { lazy, Component } from "react";
import AppRouter from "./ApplicationRouter";
import WithAuth from "../components/Auth/WithAuth";
import PellerexNotifications from "../components/Notification/PellerexNotifications";
import { initTheme } from "../common/theme";

class Landing extends Component {
  componentDidMount() {
    this.disposeTheme = initTheme();
  }

  componentWillUnmount() {
    if (this.disposeTheme) {
      this.disposeTheme();
    }
  }

  render() {
    return (
      <div>
        <AppRouter />
        <PellerexNotifications />
      </div>
    );
  }
}

export default WithAuth(Landing);
